import themeStyles from './style.css'

export default {
  palette: {
    primary1Color: themeStyles.primary1Color, //cyan500,
    primary2Color: themeStyles.primary2Color, //cyan700,
    primary3Color: themeStyles.primary3Color, //grey400,
    accent1Color: themeStyles.accent1Color, //pinkA200,
    accent2Color: themeStyles.accent2Color, //grey100,
    accent3Color: themeStyles.accent3Color, //grey500,
    //textColor: darkBlack,
    //secondaryTextColor: fade(darkBlack, 0.54),
    //alternateTextColor: white,
    //canvasColor: white,
    //borderColor: grey300,
    //disabledColor: fade(darkBlack, 0.3),
    //pickerHeaderColor: cyan500,
    //clockCircleColor: fade(darkBlack, 0.07),
    //shadowColor: fullBlack,
  },
}



// WEBPACK FOOTER //
// ./src/theme.js